function Header() {
    return <div>Header</div>
}

export default Header;